import { getAvailableDevicesWorker, getCheckSavedAlbumsChangesWorker, getDeactivateShuffleModeWorker, getTooManyRequestsCooldownWorker, getUpdatePlaybackWorker } from "../reducers/workers";
import { FIVE_SECONDS_INTERVAL_MS, ONE_SECOND_INTERVAL_MS } from "../utils/constants/otherConstants";
import ticker from "../workers/ticker";

export const SET_WORKERS_RUNNING = "SET_WORKERS_RUNNING";
export const SET_UPDATE_PLAYBACK_WORKER = "SET_UPDATE_PLAYBACK_WORKER";
export const SET_CHECK_SAVED_ALBUMS_CHANGES_WORKER = "SET_CHECK_SAVED_ALBUMS_CHANGES_WORKER";
export const SET_DEACTIVATE_SHUFFLE_MODE_WORKER = "SET_DEACTIVATE_SHUFFLE_MODE_WORKER";
export const SET_AVAILABLE_DEVICES_WORKER = "SET_AVAILABLE_DEVICES_WORKER";
export const SET_TOO_MANY_REQUESTS_COOLDOWN_WORKER = "SET_TOO_MANY_REQUESTS_COOLDOWN_WORKER";

export const setRunning = payload => ({type: SET_WORKERS_RUNNING, payload});
export const setUpdatePlaybackWorker = payload => ({type: SET_UPDATE_PLAYBACK_WORKER, payload});
export const setCheckSavedAlbumsChangesWorker = payload => ({type: SET_CHECK_SAVED_ALBUMS_CHANGES_WORKER, payload});
export const setDeactivateShuffleModeWorker = payload => ({type: SET_DEACTIVATE_SHUFFLE_MODE_WORKER, payload});
export const setAvailableDevicesWorker = payload => ({type: SET_AVAILABLE_DEVICES_WORKER, payload});
export const setTooManyRequestsCooldownWorker = payload => ({type: SET_TOO_MANY_REQUESTS_COOLDOWN_WORKER, payload});

export const startWorkers = () => {
    return (dispatch) => {
        const updatePlaybackWorker = new Worker(ticker(ONE_SECOND_INTERVAL_MS));
        const checkSavedAlbumsChangesWorker = new Worker(ticker(FIVE_SECONDS_INTERVAL_MS));
        const deactivateShuffleModeWorker = new Worker(ticker(ONE_SECOND_INTERVAL_MS));
        const availableDevicesWorker = new Worker(ticker(ONE_SECOND_INTERVAL_MS));
        const tooManyRequestsCooldownWorker = new Worker(ticker(ONE_SECOND_INTERVAL_MS));

        dispatch(setUpdatePlaybackWorker(updatePlaybackWorker));
        dispatch(setCheckSavedAlbumsChangesWorker(checkSavedAlbumsChangesWorker));
        dispatch(setDeactivateShuffleModeWorker(deactivateShuffleModeWorker));
        dispatch(setAvailableDevicesWorker(availableDevicesWorker));
        dispatch(setTooManyRequestsCooldownWorker(tooManyRequestsCooldownWorker));

        dispatch(setRunning(true));
    }
}

export const stopWorkers = () => {
    return (dispatch, getState) => {
        const state = getState();

        const updatePlaybackWorker = getUpdatePlaybackWorker(state);
        updatePlaybackWorker?.postMessage('stop');
        updatePlaybackWorker?.terminate();
        dispatch(setUpdatePlaybackWorker(undefined));

        const checkSavedAlbumsChangesWorker = getCheckSavedAlbumsChangesWorker(state);
        checkSavedAlbumsChangesWorker?.postMessage('stop');
        checkSavedAlbumsChangesWorker?.terminate();
        dispatch(setCheckSavedAlbumsChangesWorker(undefined));

        const deactivateShuffleModeWorker = getDeactivateShuffleModeWorker(state);
        deactivateShuffleModeWorker?.postMessage('stop');
        deactivateShuffleModeWorker?.terminate();
        dispatch(setDeactivateShuffleModeWorker(undefined));

        const availableDevicesWorker = getAvailableDevicesWorker(state);
        availableDevicesWorker?.postMessage('stop');
        availableDevicesWorker?.terminate();
        dispatch(setAvailableDevicesWorker(undefined));

        const tooManyRequestsCooldownWorker = getTooManyRequestsCooldownWorker(state);
        tooManyRequestsCooldownWorker?.postMessage('stop');
        tooManyRequestsCooldownWorker?.terminate();
        dispatch(setTooManyRequestsCooldownWorker(undefined));

        dispatch(setRunning(false));
    }
}